Attributes of the updated unposted position profile.
